export default "__VITE_ASSET__403c27fa__"